import React from 'react';
import { isEmpty, times, get } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { dateRangePickerPreloader as DateRangePickerPreloader } from 'ui/views/generic/dateRangePicker';
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { getVisibleItems } from 'resolvers/getVisibleEntities';
import { reportsFilters as ReportsFiltersView } from 'ui/views/widgets/reportsFilters';
import { LineChart } from 'modules/lineChart';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callTrendsDurationReports as CallTrendsDurationReports } from 'ui/views/widgets/callTrendsDurationReports';
 *
 * // render
 * <CallTrendsDurationReports propName='propValue'/>
 */

/* ------------------ */

export const callTrendsDurationReportsSuccess = ( props ) => {

    const filterFields = getVisibleItems( props.structure.filtersConfig.fields, props.visibility );
    const widgetConfig = get( props, 'structure.widgetConfig' );

    return (
        <div className='ui-call-trends-duration-reports'>

            {/* Header and the filters */}
            <ReportsFiltersView
                filterFields={ filterFields }
                filterData={ props.filterData } // options and selected values
                widgetConfig={ widgetConfig }
                onOptionSelect={ props.onOptionSelect }
                onCagChange={ props.onCagChange }
                onClearFilter={ props.onClearFilter }
                onFilterSelect={ props.onFilterSelect }
            />

            {/* Reporting Charts */}
            <div className='ui-call-trends-duration-reports__charts'>
                <div className='ui-call-trends-duration-reports__charts__chart'>
                    {
                        ! props.isChartFetching && ! isEmpty( get( props, 'barGraphData', {} ) ) ? (
                            <div className='ui-call-trends-duration-reports__charts__chart__title'>
                                <div className='ui-call-trends-duration-reports__charts__chart__title__count'>
                                    { get( props, 'barGraphData.totalCalls' ) }
                                </div>
                            </div>
                        ) : null
                    }
                    <LineChart
                        data = { get( props, 'barGraphData.chartData', {} ) }
                        className='ui-call-trends-duration-reports__charts__chart__bar-chart'
                        isFetching={ props.isChartFetching }
                        onClickHandler={ props.onBarChartClickHandler }
                        networkStatus={ props.graphNetworkStatus }
                        yAxislabel={get( props, 'barGraphData.config.reportConfig.yAxisLabel', '' ) }
                    />
                </div>
            </div>
        </div>
    );
};

// set display name
callTrendsDurationReportsSuccess.displayName = 'callTrendsDurationReports';

// set default props
callTrendsDurationReportsSuccess.defaultProps = {};

// prop types
callTrendsDurationReportsSuccess.propTypes = {};

/* ********************************************** */

export const callTrendsDurationReportsPreloader = () => {

    return (
        <div className='ui-call-trends-duration-reports-preloader'>
            <div className='ui-call-trends-duration-reports-preloader__header'>
                <div className='ui-call-trends-duration-reports-preloader__header__title'></div>
                <DateRangePickerPreloader
                    className='ui-call-trends-duration-reports-preloader__header__date-range'
                />
                <div className='ui-call-trends-duration-reports-preloader__header__cag'>
                    <div className='ui-call-trends-duration-reports-preloader__header__cag__title'></div>
                    <div className='ui-call-trends-duration-reports-preloader__header__cag__choice'></div>
                </div>
                <div className='ui-call-trends-duration-reports-preloader__header__reasons'>
                    <div className='ui-call-trends-duration-reports-preloader__header__reasons__title'></div>
                    <div className='ui-call-trends-duration-reports-preloader__header__reasons__choice'></div>
                </div>
                <div className='ui-call-trends-duration-reports-preloader__header__agents'>
                    <div className='ui-call-trends-duration-reports-preloader__header__agents__title'></div>
                    <div className='ui-call-trends-duration-reports-preloader__header__agents__choice'></div>
                </div>
            </div>

            <div className='ui-call-trends-duration-reports-preloader__filters'>
                { times( 4 ).map( index => {
                    return (
                        <div key={ index } className='ui-call-trends-duration-reports-preloader__filters__filter'>
                            <div className='ui-call-trends-duration-reports-preloader__filters__filter__title'></div>
                            <div className='ui-call-trends-duration-reports-preloader__filters__filter__options'>
                                { times( 4 ).map( _index => {
                                    return (
                                        <div key={ _index } className='ui-call-trends-duration-reports-preloader__filters__filter__options__option'>
                                            <div className='ui-call-trends-duration-reports-preloader__filters__filter__options__option__checkbox'></div>
                                            <div className='ui-call-trends-duration-reports-preloader__filters__filter__options__option__title'></div>
                                        </div>
                                    );
                                } ) }
                            </div>
                        </div>
                    );
                } ) }
            </div>
            <div className='ui-call-trends-duration-reports-preloader__chart'>
                <WidgetPreloader />
            </div>
        </div>
    );
};

// set display name
callTrendsDurationReportsPreloader.displayName = 'callTrendsDurationReportsPreloader';

// set default props
callTrendsDurationReportsPreloader.defaultProps = {};

// prop types
callTrendsDurationReportsPreloader.propTypes = {};

export const callTrendsDurationReports = withNetworkState( callTrendsDurationReportsPreloader, callTrendsDurationReportsSuccess );

